import React, { memo } from "react";
import NodeWrapper from "./NodeWrapper";
import { ContactPhone } from "@mui/icons-material";

/**
 * Send Contact — Enviar cartao de contato (vCard).
 *
 * data.contactName: string — nome no vCard
 * data.contactPhone: string — telefone
 * data.contactEmail: string (opcional)
 * data.contactOrg: string (opcional) — empresa/organizacao
 *
 * Saida: handle "a" (default)
 */
const SendContactNode = memo(({ id, data, isConnectable, selected }) => {
  const name = data?.contactName || "";
  const phone = data?.contactPhone || "";

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<ContactPhone />}
      title="Enviar Contato"
      color="#00838F"
      bgColor="#E0F7FA"
      isConnectable={isConnectable}
      selected={selected}
      minWidth={200}
    >
      <div style={{
        background: "#fff",
        border: "1px solid #e0e0e0",
        borderRadius: 6,
        padding: "6px 10px",
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: "#00695C" }}>
          {name || "Nome nao definido"}
        </div>
        <div style={{ fontSize: 11, color: "#666", fontFamily: "monospace" }}>
          {phone || "Telefone nao definido"}
        </div>
      </div>
    </NodeWrapper>
  );
});

SendContactNode.displayName = "SendContactNode";
export default SendContactNode;
